/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module link
 */

import Link from './link';
import LinkEditing from './linkediting';
import LinkUI from './linkui';
import LinkImage from './linkimage';
import LinkImageEditing from './linkimageediting';
import LinkImageUI from './linkimageui';
import AutoLink from './autolink';

export default {
	Link,
	LinkEditing,
	LinkUI,
	LinkImage,
	LinkImageEditing,
	LinkImageUI,
	AutoLink
};
